import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6aa1060a2253d30014c78d53_1788946552510_7839b0b5/gameforge/src/app/sign-up-login-screen/components/AuthScreen.tsx");
